import _ from 'lodash'
import React from 'react'
import Slider from 'react-slick'
import CarouselArrow from './carouselArrow'
import Carousel32_9Items from './carousel32Items'

import 'slick-carousel/slick/slick.css'
import './slick-theme.css'
import './style.scss'

class Carousel32 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.data && props.data.contentData
    }
  }

  componentDidMount(){
    this.setState({
      innerWidth: window.innerWidth
    })
  }

  render() {
    const hasMultipleItems = this.state.items && this.state.items.length > 1
    return <div className="carousel32">
      <div className={`carousel ` + (_.get(this.props, "layout.settings.isHidden") ? "hide" : "")}>
        {this.state.items && this.state.items.length > 0 && 
          <Slider dots={hasMultipleItems} infinite={hasMultipleItems} arrows={hasMultipleItems} nextArrow={<CarouselArrow itemCount={this.state.items.length} />} prevArrow={<CarouselArrow itemCount={this.state.items.length} />} autoplay={hasMultipleItems} speed={750} cssEase="ease-in-out" autoplaySpeed={4000} lazyLoad={true}>
            {this.state.items.map((item, i) => <div key={i}>
              <Carousel32_9Items layoutSettings={this.props.layout.settings} item={item} maxWidth={this.state.innerWidth || 1000} />
            </div>)}
          </Slider>}
      </div>
    </div>;
  }
}

export default Carousel32
